export const GET_MESSAGES_LIST = 'GET_MESSAGES_LIST';
export const CREATE_MESSAGE = 'CREATE_MESSAGE';

/**
 * Get list of messages
 * @function getMessagesList
 * @param {String} userID current user id
 */
export function getMessagesList(userID) {
  return {
    type: GET_MESSAGES_LIST,
    request: {
      op: 'get',
      path: `@messages?userid=${userID}`,
    },
  };
}

/**
 * Create message
 * @function createMessage
 * @param {Number} pratica_id pratica id
 * @param {String} text messaggio
 */
export function createMessage(
  pratica_id,
  text,
  send_email = true,
  attachments = [],
) {
  return {
    type: CREATE_MESSAGE,
    request: {
      op: 'post',
      path: `/@message`,
      data: {
        pratica_id: pratica_id,
        message: text,
        notify_on_email: send_email,
        attachments: attachments,
      },
    },
  };
}
